////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

/*
const stringContainsPositiveIntegerRegex = /^(\+|-)?[0-9][\d]*$/

const validateIntegerRange = (value, lower, upper, value_name, errors) => {
  if (!value) {
    errors[value_name] = 'Required'
  } else if (isNaN(value) || !stringContainsPositiveIntegerRegex.test(value)) {
    errors[value_name] = 'Must an integer'
  } else if (parseInt(value)>upper || parseInt(value)<lower){
    errors[value_name] = `Must be between ${lower} and ${upper}`
  }
}
*/

const validate = values => {
    const errors = {}
    for (let field of ["eirp_dbw", "peak", "elevation_m_AGL", "azimuth", "tilt", "antenna"]){
        if (!values[field] && isNaN(values[field])){
            errors[field] = 'Required'
          }    
    }


    return errors
  }
  
  export default validate
  